module.exports = __webpack_public_path__ + "static/media/bg-element.889d24bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-element.svg
// module id = 261
// module chunks = 0